import useSWR from 'swr';
import SortOrder from '@/constants/SortOrder';
import useOwnerOrgId from '@/lib/hooks/useOwnerOrgId';
import { useCurrentUser } from '@/lib/hooks/userData';
import { fetcher } from '@/utils/services';
import { TaskSortBy as SortBy } from '../tasksConfig';

const useSavedFilters = () => {
  const ownerOrgId = useOwnerOrgId();
  const { user } = useCurrentUser(true);
  const { userId } = user;

  const {
    data: employeeData,
    error,
    isValidating,
  } = useSWR(
    userId &&
      `tasks?owner_org_id=${ownerOrgId}&user_id=${userId}&sort_by=${SortBy.DUE_DATE}&sort_order=${SortOrder.ASC}&is_completed=false&page_size=3`,
    fetcher,
    { revalidateOnFocus: false },
  );

  const { data: orgData } = useSWR(
    `tasks?owner_org_id=${ownerOrgId}&is_completed=false&page_size=1`,
    fetcher,
    { revalidateOnFocus: false },
  );

  return {
    employeeTotalTasks: employeeData?.totalHits,
    error,
    isValidating,
    orgTotalTasks: orgData?.totalHits || 0,
    tasks: employeeData?.tasks,
    userId,
  };
};

export default useSavedFilters;
